<div class="languages svi-dialog">
    <div class="tooltip__arrow"></div>
    <ng-container *ngFor="let language of languages">
        <a class="language" [class.active]="isLanguageSelected(language.code)" (click)="setLanguage(language.code)">{{language.labelCode}}</a>
        <span class="separator"></span>
    </ng-container>
</div>